import { render } from "./CallLog.vue?vue&type=template&id=bfe0b28a&scoped=true"
import script from "./CallLog.vue?vue&type=script&lang=js"
export * from "./CallLog.vue?vue&type=script&lang=js"

import "./CallLog.vue?vue&type=style&index=0&id=bfe0b28a&lang=less&scoped=true"

import exportComponent from "/Users/april/Desktop/hz_pro_vue3/mail-task-front-end/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bfe0b28a"]])

export default __exports__